import React, { useEffect, useState } from "react";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validate from "./form-validate";

const EmpresaCadastrar = () => {
  const [state, setState] = useState({
    id: 0,
    titulo: "",
    texto: "",
    missao: "",
    visao: "",
    valores: "",
    endereco: "",
    titulo_in: "",
    texto_in: "",
    missao_in: "",
    visao_in: "",
    valores_in: "",
    titulo_es: "",
    texto_es: "",
    missao_es: "",
    visao_es: "",
    valores_es: "",
    imagem: "",
    link_catalogo_pdf: "",
    link_catalogo_acessorios: "",
    link_video: "",
    email: "",
    email_orcamento: "",
    telefone: "",
    telefone_filial: "",
    endereco_filial: "",
    politica_privacidade: "",
    politica_privacidade_in: "",
    politica_privacidade_es: "",
    imagem_produto: "",
    imagem_plano_fundo: ""
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const carregarDados = async () => {
    try {
      showLoading(".ibox-content");

      const requisicao = await api.get(`/empresa/consultar`);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      setState(data.data);
    } catch (error) {
      console.log(error);
      danger("Erro ao carregar os dados da empresa");
    } finally {
      showLoading(".ibox-content");
    }
  };

  const onChangeImagem = (e) => {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      setState({ ...state, imagem: file, imagePreviewUrl: reader.result });
    };

    reader.readAsDataURL(file);
  };

  const onChangeImagemProduto = (e) => {
    e.preventDefault();

    let reader = new FileReader();
    let fileProduto = e.target.files[0];

    reader.onloadend = () => {
      setState({ ...state, imagem_produto: fileProduto, imagePreviewProdutoUrl: reader.result });
    };

    reader.readAsDataURL(fileProduto);
  };

  const onChangeImagemPrincipal = (e) => {
    e.preventDefault();

    let reader = new FileReader();
    let filePrincipal = e.target.files[0];

    reader.onloadend = () => {
      setState({ ...state, imagem_plano_fundo: filePrincipal, imagePreviewPrincipalUrl: reader.result });
    };

    reader.readAsDataURL(filePrincipal);
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-empresa").valid()) {
      return;
    }

    try {
      const formData = new FormData();

      formData.append("id", state.id);
      formData.append("titulo", state.titulo);
      formData.append("texto", state.texto);
      formData.append("missao", state.missao);
      formData.append("visao", state.visao);
      formData.append("valores", state.valores);
      formData.append("endereco", state.endereco);
      formData.append("endereco_filial", state.endereco_filial);
      formData.append("telefone", state.telefone);
      formData.append("telefone_filial", state.telefone_filial);
      formData.append("email", state.email);
      formData.append("email_orcamento", state.email_orcamento);
      formData.append("link_video", state.link_video);
      formData.append("link_catalogo_pdf", state.link_catalogo_pdf);
      formData.append("link_catalogo_acessorios", state.link_catalogo_acessorios);
      formData.append("politica_privacidade", state.politica_privacidade);

      formData.append("titulo_in", state.titulo_in);
      formData.append("texto_in", state.texto_in);
      formData.append("missao_in", state.missao_in);
      formData.append("visao_in", state.visao_in);
      formData.append("valores_in", state.valores_in);
      formData.append("politica_privacidade_in", state.politica_privacidade_in);

      formData.append("titulo_es", state.titulo_es);
      formData.append("texto_es", state.texto_es);
      formData.append("missao_es", state.missao_es);
      formData.append("visao_es", state.visao_es);
      formData.append("valores_es", state.valores_es);
      formData.append("politica_privacidade_es", state.politica_privacidade_es);
console.log(state.imagem_produto);
console.log(state.imagem_plano_fundo);
      if (state.imagem_produto) {
        formData.append("imagem_produto", state.imagem_produto);
      }

      if (state.imagem_plano_fundo) {
        formData.append("imagem_plano_fundo", state.imagem_plano_fundo);
      }

      if (state.imagem) {
        formData.append("imagem", state.imagem);
      }

      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/empresa", formData);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      document.getElementById("imagem").value = null;
      carregarDados();
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar a empresa.");
    }
  };

  useEffect(() => {
    carregarDados();

    let validacao = window.$("#form-empresa").validate(validate);

    return () => validacao.destroy();
  }, []);

  return (
    <>
      <Layout
        titulo="Ibraflex - Empresa"
        header="Cadastro da Empresa"
        action={{ titulo: "Voltar", link: "/empresa" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados da empresa</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <form id="form-empresa">
                  <div className="row">
                    <div className="col-lg-3">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Imagem da empresa</label>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <img
                              src={
                                state.imagePreviewUrl
                                  ? state.imagePreviewUrl
                                  : state.url
                              }
                              alt="Imagem da Empresa"
                              id="imagem-empresa"
                              style={{
                                maxWidth: "100%",
                                height: "180px",
                                width: "100%",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <input
                              type="file"
                              placeholder="Imagens da empresa"
                              className="form-control"
                              id="imagem"
                              name="imagem"
                              accept="image/*"
                              onChange={onChangeImagem}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-9">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Endereço da empresa</label>
                            <input
                              type="text"
                              placeholder="Endereço da empresa"
                              className="form-control"
                              name="endereco"
                              value={state.endereco}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>
                              Link do video institucional da empresa
                            </label>
                            <input
                              type="text"
                              placeholder="Link video institucional da empresa"
                              className="form-control"
                              name="link_video"
                              value={state.link_video}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Link do catálogo de esteiras e correntes</label>
                            <input
                              type="text"
                              placeholder="Link do catálogo de esteiras e correntes"
                              className="form-control"
                              name="link_catalogo_pdf"
                              value={state.link_catalogo_pdf}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Link do catálogo de acessórios</label>
                            <input
                              type="text"
                              placeholder="Link do catálogo acessórios"
                              className="form-control"
                              name="link_catalogo_acessorios"
                              value={state.link_catalogo_acessorios}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Telefone da empresa</label>
                            <input
                              type="text"
                              placeholder="Telefone da empresa"
                              className="form-control"
                              name="telefone"
                              value={state.telefone}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>E-mail da empresa</label>
                            <input
                              type="text"
                              placeholder="E-mail da empresa"
                              className="form-control"
                              name="email"
                              value={state.email}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>E-mail orçamento</label>
                            <input
                              type="text"
                              placeholder="E-mail dos orçamentos"
                              className="form-control"
                              name="email_orcamento"
                              value={state.email_orcamento}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div className="col-lg-6">
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label>Imagem do módulo de Linhas e Produtos</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <img
                                                src={
                                                    state.imagePreviewProdutoUrl
                                                    ? state.imagePreviewProdutoUrl
                                                    : state.url_imagem_produto
                                            }
                                            alt="Imagem do Módulo"
                                            id="imagem-produto"
                                            style={{
                                                maxWidth: "100%",
                                                height: "180px",
                                                width: "100%",
                                            }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <input
                                                type="file"
                                                placeholder="Imagem Produto"
                                                className="form-control"
                                                id="imagem_produto"
                                                name="imagem_produto"
                                                accept="image/*"
                                                onChange={onChangeImagemProduto}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>   

                        <div className="col-lg-6">
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label>Imagem do plano de fundo do Aplicativo</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <img
                                                src={
                                                    state.imagePreviewPrincipalUrl
                                                    ? state.imagePreviewPrincipalUrl
                                                    : state.url_plano_fundo
                                            }
                                            alt="Imagem do Plano de Fundo"
                                            id="imagem_plano_fundo"
                                            style={{
                                                maxWidth: "100%",
                                                height: "180px",
                                                width: "100%",
                                            }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <input
                                                type="file"
                                                placeholder="Imagem Plano de Fundo"
                                                className="form-control"
                                                id="imagem_plano_fundo"
                                                name="imagem_plano_fundo"
                                                accept="image/*"
                                                onChange={onChangeImagemPrincipal}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>  
                        </div>  
                      </div>

                      <div class="row">
                        <div class="col-lg-12">
                          <div className="form-group">
                            <div class="tabs-container">
                              <ul class="nav nav-tabs" role="tablist">
                                <li>
                                  <a
                                    class="nav-link active nav-tab"
                                    data-toggle="tab"
                                    href="#tab-1"
                                  >
                                    Português
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link nav-tab"
                                    data-toggle="tab"
                                    href="#tab-2"
                                  >
                                    Inglês
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link nav-tab"
                                    data-toggle="tab"
                                    href="#tab-3"
                                  >
                                    Espanhol
                                  </a>
                                </li>
                              </ul>
                              <div class="tab-content">
                                <div
                                  role="tabpanel"
                                  id="tab-1"
                                  class="tab-pane active"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Título da empresa</label>
                                          <input
                                            type="text"
                                            placeholder="Título da empresa"
                                            className="form-control"
                                            name="titulo"
                                            value={state.titulo}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Texto da empresa</label>
                                          <textarea
                                            className="form-control"
                                            id="texto"
                                            name="texto"
                                            placeholder="Texto da empresa."
                                            rows="8"
                                            value={state.texto}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Missão da empresa</label>
                                          <textarea
                                            className="form-control"
                                            id="missao"
                                            name="missao"
                                            placeholder="Missão da empresa."
                                            rows="2"
                                            value={state.missao}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Visão da empresa</label>
                                          <textarea
                                            className="form-control"
                                            id="visao"
                                            name="visao"
                                            placeholder="Visão da empresa."
                                            rows="2"
                                            value={state.visao}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Valores da empresa</label>
                                          <textarea
                                            className="form-control"
                                            id="valores"
                                            name="valores"
                                            placeholder="Valores da empresa."
                                            rows="2"
                                            value={state.valores}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>
                                            Política de privacidade da empresa
                                          </label>
                                          <textarea
                                            className="form-control"
                                            id="politica_privacidade"
                                            name="politica_privacidade"
                                            placeholder="Política de privacidade da empresa."
                                            rows="8"
                                            value={state.politica_privacidade}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  role="tabpanel"
                                  id="tab-2"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Título da empresa</label>
                                          <input
                                            type="text"
                                            placeholder="Título da empresa"
                                            className="form-control"
                                            name="titulo_in"
                                            value={state.titulo_in}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Texto da empresa</label>
                                          <textarea
                                            className="form-control"
                                            id="texto"
                                            name="texto_in"
                                            placeholder="Texto da empresa."
                                            rows="8"
                                            value={state.texto_in}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Missão da empresa</label>
                                          <textarea
                                            className="form-control"
                                            id="missao"
                                            name="missao_in"
                                            placeholder="Missão da empresa."
                                            rows="2"
                                            value={state.missao_in}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Visão da empresa</label>
                                          <textarea
                                            className="form-control"
                                            id="visao"
                                            name="visao_in"
                                            placeholder="Visão da empresa."
                                            rows="2"
                                            value={state.visao_in}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Valores da empresa</label>
                                          <textarea
                                            className="form-control"
                                            id="valores"
                                            name="valores_in"
                                            placeholder="Valores da empresa."
                                            rows="2"
                                            value={state.valores_in}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>
                                            Política de privacidade da empresa
                                          </label>
                                          <textarea
                                            className="form-control"
                                            id="politica_privacidade_in"
                                            name="politica_privacidade_in"
                                            placeholder="Política de privacidade da empresa."
                                            rows="8"
                                            value={
                                              state.politica_privacidade_in
                                            }
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  role="tabpanel"
                                  id="tab-3"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Título da empresa</label>
                                          <input
                                            type="text"
                                            placeholder="Título da empresa"
                                            className="form-control"
                                            name="titulo_es"
                                            value={state.titulo_es}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Texto da empresa</label>
                                          <textarea
                                            className="form-control"
                                            id="texto"
                                            name="texto_es"
                                            placeholder="Texto da empresa."
                                            rows="8"
                                            value={state.texto_es}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Missão da empresa</label>
                                          <textarea
                                            className="form-control"
                                            id="missao"
                                            name="missao_es"
                                            placeholder="Missão da empresa."
                                            rows="2"
                                            value={state.missao_es}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Visão da empresa</label>
                                          <textarea
                                            className="form-control"
                                            id="visao"
                                            name="visao_es"
                                            placeholder="Visão da empresa."
                                            rows="2"
                                            value={state.visao_es}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Valores da empresa</label>
                                          <textarea
                                            className="form-control"
                                            id="valores"
                                            name="valores_es"
                                            placeholder="Valores da empresa."
                                            rows="2"
                                            value={state.valores_es}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>
                                            Política de privacidade da empresa
                                          </label>
                                          <textarea
                                            className="form-control"
                                            id="politica_privacidade_es"
                                            name="politica_privacidade_es"
                                            placeholder="Política de privacidade da empresa."
                                            rows="8"
                                            value={
                                              state.politica_privacidade_es
                                            }
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default EmpresaCadastrar;
